<template>
    <div class="blog-area pt-100 pb-70">
        <div class="container">
            <div class="section-title" v-for="title of titles" :key="title.title_id">
                <span class="sub-title">{{ title.title_title }}</span>
                <h2 class="font-weight-black">{{ title.title_header }}</h2>
                <p>{{ title.title_content }}</p>
            </div>
            <div class="row justify-content-center">

                <div class="col-lg-4 col-md-6 col-sm-6 mb-5" v-for="blog of blogs" :key="blog.blog_id">
                    <router-link :to="getUrl(blog.blog_id)" class="single-blog-item">
                        <div class="post-image">
                            <div class="d-block">
                                <img :src="getImgUrl('bloglar', blog.blog_img)" :alt="blog.blog_header">
                            </div>
                            <div class="link-btn"></div>
                        </div>
                        <div class="post-content">
                            <div class="category">DRY Ana Okulu</div>
                            <h3 class="font-weight-black">
                                <div>
                                    {{ blog.blog_header }}
                                </div>
                            </h3>
                        </div>
                    </router-link>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";



export default {
    name: 'Blog',
    props: ['pathUrl'],

    created() {
        this.getTitles();
        this.getBlogs();
    },
    data() {
        return {
            titles: [],
            blogs: [],
            errors: []
        };
    },
    methods: {
        getTitles() {
            axios
                .get(this.pathUrl + "?data=title&parent=9")
                .then(response => (this.titles = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getBlogs() {
            axios
                .get(this.pathUrl + "?data=blog")
                .then(response => (this.blogs = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/' + category + '/' + pet)
        },
        getUrl(pet) {
            return 'bloglar/' + pet
        }
    }
}
</script>